import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import javascript from "highlight.js/lib/languages/javascript";
import markdown from "highlight.js/lib/languages/markdown";
import plaintext from "highlight.js/lib/languages/plaintext";

import { CodeStyled } from "./CodeBlock.styled";

hljs.registerLanguage("bash", bash);
hljs.registerLanguage("markdown", markdown);
hljs.registerLanguage("javascript", javascript);
hljs.registerLanguage("plaintext", plaintext);

interface CodeBlockProps {
  code: string;
  className?: string;
}

export const CodeBlock = ({ code, className }: CodeBlockProps) => {
  const language = className?.replace("language-", "") ?? "plaintext";

  return (
    <CodeStyled
      className={`${language} hljs`}
      dangerouslySetInnerHTML={{
        __html: hljs.highlight(code, { language }).value,
      }}
    />
  );
};
